import React from 'react'
import {_GPY,__GPYPost,__GPYGet} from '../env.js'
import Footer from '../Footer.js'

import Navigation from './navigation/Navigation.js'
import Dashboard from './dashboard/Dashboard.js'
import OutputConfig from './outputconfig/OutputConfig.js'
import OverlayConfig from './overlayconfig/OverlayConfig.js'
import Advertisement from './advertisement/Advertisement'
import Fonts from './fonts/Fonts.js'
import UserAccount from './user/UserAccount.js'
import UserSubscription from './user/UserSubscription.js'
import UserBills from './user/UserBills.js'

import Referee from './gametypes/referee/Referee.js'
import Crew from './gametypes/crew/Crew.js'

import SoccerFootball from './gametypes/soccerfootball/SoccerFootball.js'
import IceHockey from './gametypes/IceHockey/IceHockey.js'
import Hockey from './gametypes/Hockey/Hockey.js'
import Cricket from './gametypes/Cricket/Cricket.js'
import AmericanFootball from './gametypes/AmericanFootball/AmericanFootball.js'
import Handball from './gametypes/Handball/Handball.js'


import Bowling from './gametypes/bowling/Bowling.js'
import Volleyball from './gametypes/Volleyball/Volleyball.js'
import Drift from './gametypes/drift/Drift.js'

import Basketball from './gametypes/Basketball/Basketball.js'
import ComingSoon from './gametypes/comingsoon/ComingSoon.js'
import IncastContentTV from './gametypes/IncastContentTV/IncastContentTV.js'
import LiveTV from './gametypes/LiveTV/LiveTV.js'

import Unknowni18nKeys from '../i18n/Unknowni18nKeys.js'
import BugReport from './BugReport.js'
import WaitCube from '../WaitCube.js'
import Fullscreen from "react-full-screen";


class Scoreboard extends React.Component {

  constructor (props) {
	    super(props)

      this.state = {
		      error: null,
		      isLoaded: false,
		      gameTypes: {MenuItems: {MenuItem: []}},
		      menuLinks: {MenuItems: {MenuItem: []}},
		      gameType: _GPY.uiStates.gameType,
		      menuError: null,

		      gameMenuInView: _GPY.uiStates.gameMenuInView !== undefined ? _GPY.uiStates.gameMenuInView : _GPY.uiStates.gameType + 'SB',
		      menuIsLoaded: false,
		      showOBSPanel: _GPY.uiStates.showOBSPanel !== undefined ? _GPY.uiStates.showOBSPanel : false,
					eventHandler:{},
          isFull: false,
		    }
	}

  registerEventHandler(name,e) {
      console.log("Register EventHandler:" + name);
			var h = this.state.eventHandler;
      h[name] = e;
      this.setState({eventHandler:h});
	}


  setGameType (f) {
			 console.log("scoreboad.setGameType:"+f);
	     this.setState({gameType: f})
       __GPYPost('setGameType',{gameType: f},(res) => {
         if (res.Result.state === 'OK') {
           this.loadMenuItems();
         } else {
         }
       });
  }

	onMenu(obj) {
    console.log("onMenu",this.state.eventHandler);
		Object.keys(this.state.eventHandler).forEach(key => {
				var c = this.state.eventHandler[key];
				if(c !== undefined && c.onMenu !== undefined){
					c.onMenu(obj);
				}
		});
	}

  setGameMenuInView (f) {
				this.onMenu(f);
         __GPYPost('setUIState',{gameMenuInView: f});
	}

	componentDidMount () {
      _GPY.loadFonts(()=>{
		      this.loadGameTypes();
		      this.loadMenuItems();
      });
	}

  loadGameTypes () {
    __GPYGet('getAvailableGameTypes',(result) => {
      this.setState({
          isLoaded: true,
          gameTypes: result
      });
     },(error)=>{
      this.setState({
         isLoaded: true,
          error
       });
    });
  }

	loadMenuItems () {
      __GPYGet('getMenuItems',(result) => {
        this.setState({
          menuIsLoaded: true,
          menuLinks: result
        });
      },(error)=>{
        this.setState({
          menuIsLoaded: false,
          error
        });
      });
	 }

	 render () {

   		const {gameTypes, gameType, error, isLoaded, menuLinks, gameMenuInView} = this.state

		  if (error) {
		 		 return (<div>Error: {error.message}</div>);
		  } else if (!isLoaded) {
		 	   return (<WaitCube/>);
		  }

				   var self = this;

				   return (
				     <div>
             <Fullscreen  enabled={this.state.isFull}  onChange={(isFull) => this.setState({isFull})}>
               <Navigation scoreboard={this} menuLinks={menuLinks} gameType={gameType} gameTypes={gameTypes} setGameMenuInView={(f)=> this.setGameMenuInView(f)} setGameType={(gt) => this.setGameType(gt)} guppyi={this.props.guppyi} />
				       <div className='container-fluid'>

				         <div className='row'>
				           <div className='col'>
                   {gameType==='Dashboard'?<Dashboard scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}

                   {gameType==='OutputConfig'?<OutputConfig scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='OverlayConfig'?<OverlayConfig scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='UserAdvertisement'?<Advertisement usageType="ADVERTISING" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='UserAdvertisementSponsor'?<Advertisement usageType="SPONSOR" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='UserAccount'?<UserAccount scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='UserSubscription'?<UserSubscription scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='UserBills'?<UserBills scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Referee'?<Referee scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Crew'?<Crew scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Fonts'?<Fonts scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='BugReport'?<BugReport scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}

                   {gameType==='SoccerFootball'?<SoccerFootball scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='IceHockey'?<IceHockey name="IceHockey" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Volleyball'?<Volleyball name="Volleyball" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Hockey'?<Hockey name="Hockey" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='LiveTV'?<LiveTV name="LiveTV" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='AmericanFootball'?<AmericanFootball name="AmericanFootball" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Handball'?<Handball name="Handball" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}


                   {_GPY.uiStates.userLvl > _GPY.USER_EXPERT?
                     <>
                     {gameType==='Bowling'?<Bowling scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                     {gameType==='Drift'?<Drift scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                     {gameType==='Cricket'?<Cricket name="Cricket" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}

                     {gameType==='IncastContentTV'?<IncastContentTV scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                     {gameType==='UnknownI18nKeys'?<Unknowni18nKeys scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                    </>
                   :""}

                   {gameType==='Baseball'?<ComingSoon name="Baseball" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Basketball'?<Basketball name="Basketball" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Floorball'?<ComingSoon name="Floorball" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Lacrosse'?<ComingSoon name="Lacrosse" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}
                   {gameType==='Waterpolo'?<ComingSoon name="Waterpolo" scoreboard={self} view={gameMenuInView} gameTypes={gameTypes} setGameType={(gt)=>this.setGameType(gt)} guppyi={self.props.guppyi} />:""}

                   </div>
				         </div>
				       </div>

              <Footer/>

               </Fullscreen>
				     </div>
				   );
		}
}
export default Scoreboard
